import { state } from './state';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const MODULE_NAME = 'account';

const AccountModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default AccountModule;
